// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1WDfM","label":"CategoryService_label__3WqzD","location":"CategoryService_location__ykWFj"};